import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { FindingDefinitionCreate } from "@/features/catalog";
import { findingDefinitionRouteId } from "@/features/catalog/lib/finding-definition-route";

export const Route = createFileRoute("/catalog/findings/new")({
  beforeLoad: ({ context }) => {
    if (!context.permissions.canWrite("ObservationDefinition")) throw redirect({ to: "/catalog/exams" });
  },
  component: NewFindingDefinition,
});

function NewFindingDefinition() {
  const navigate = useNavigate();
  return (
    <FindingDefinitionCreate
      onDone={(url) =>
        navigate({ to: "/catalog/findings/$findingId", params: { findingId: findingDefinitionRouteId(url) } })
      }
      onCancel={() => navigate({ to: "/catalog/exams" })}
    />
  );
}
